import React from 'react';
import PropTypes from 'prop-types';
import OSMHoursEditor from './OSMHoursEditor.jsx';
import { BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE } from '../../backend/constants';

import styles from './OSMHoursEditor.module.scss';

const { REPLACE } = BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE;

const BulkOSMHoursEditor = ({ changeType, ...props }) => changeType === REPLACE && <OSMHoursEditor {...props} className={styles.bulkHoursEditor} />;

BulkOSMHoursEditor.propTypes = {
    className: PropTypes.string,
    configuredLinesString: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    changeType: PropTypes.string,
};

BulkOSMHoursEditor.defaultProps = {
    className: '',
    configuredLinesString: '',
    disabled: false,
    onChange: () => {},
    changeType: '',
};

export default BulkOSMHoursEditor;
